import { PulseEnvironment } from '@pulse/browser-shared';
import { AnalyticsPlugin, IPulsePluginContext } from '@pulse/common';
import { RUMService } from '../services';

export class RUMPlugin implements AnalyticsPlugin {
    constructor(
        private rum: RUMService,
        private env: PulseEnvironment,
    ) {}

    init(ctx: IPulsePluginContext) {
        this.rum.subscribe(ctx.config.rumReport, ctx.config.rumReportOnce).subscribe((entry) => {
            this.env.win.dataLayer?.push({ pulse: 'event', event: 'rum', data: entry });
        });
    }
}
